import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginFormComponent, ResetPasswordFormComponent, CreateAccountFormComponent, ChangePasswordFormComponent } from './shared/components';
import { AuthGuardService } from './shared/services';
import { ProfileComponent } from './pages/profile/profile.component';
import { TasksComponent } from './pages/tasks/tasks.component';
import { DxDataGridModule, DxFormModule } from 'devextreme-angular';
import { VisaApplicationListComponent } from './pages/visa-application-list/visa-application-list.component';
import { EventlogComponent } from './pages/eventlog/eventlog.component';
import { DefinationComponent } from './pages/defination/defination.component';
import { AboutComponent } from './pages/about/about.component';
import { PoliciesKvkkComponent } from './pages/policies-kvkk/policies-kvkk.component';
import { FrequentlyAskedQuestionsComponent } from './pages/frequently-asked-questions/frequently-asked-questions.component';
import { BlogComponent } from './pages/blog/blog.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { SubscribeComponent } from './pages/subscribe/subscribe.component';
import { SiteDescriptionComponent } from './pages/site-description/site-description.component';
import { PercentageComponent } from './pages/percentage/percentage.component';
import { VisaDefinationComponent } from './pages/visa-definition/visa-definition.component';
import { DiscountDefinitionComponent } from './pages/discount-definition/discount-definition.component';
import { AdminSliderComponent } from './pages/slider/slider.component';

const routes: Routes = [
  // {
  //   path: 'tasks',
  //   component: TasksComponent,
  //   canActivate: [AuthGuardService]
  // },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['Editor', 'VehicleStaff'] }
  },
  {
    path: 'slider',
    component: AdminSliderComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['Editor', 'VehicleStaff'] }
  },
  {
    path: 'home',
    component: DashboardComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['Editor', 'VehicleStaff'] }
  },
  {
    path: 'login-form',
    component: LoginFormComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordFormComponent,
  },
  {
    path: 'create-account',
    component: CreateAccountFormComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'change-password/:recoveryCode',
    component: ChangePasswordFormComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordFormComponent,
  },
  {
    path: 'visa-application-list',
    component: VisaApplicationListComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'defination',
    component: DefinationComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'visa-definition',
    component: VisaDefinationComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'discount-definition',
    component: DiscountDefinitionComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'eventlog',
    component: EventlogComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'about',
    component: AboutComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['Editor'] }
  },
  {
    path: 'policies-kvkk',
    component: PoliciesKvkkComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['Editor'] }
  },
  {
    path: 'frequently-asked-questions',
    component: FrequentlyAskedQuestionsComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['Editor'] }
  },
  {
    path: 'blog',
    component: BlogComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['Editor'] }
  },
  {
    path: 'percentage',
    component: PercentageComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['VehicleStaff'] }
  },
  {
    path: 'site-description',
    component: SiteDescriptionComponent,
    canActivate: [AuthGuardService],
    data: { roles: ['Editor'] }
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false }), DxDataGridModule, DxFormModule],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: [
    ProfileComponent,
    TasksComponent
  ]
})
export class AppRoutingModule { }
